import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue";
import _imports_0 from '@/assets/LinkIcon.svg';
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { key: 1 };
import { ref, onMounted } from 'vue';
import { useAuth } from '@/composables/useAuth';
import { useAppState } from '@/composables/useAppState';
import { useCustomer } from '@/composables/useCustomer';
import { getHttpInstance } from '@/composables/useApi';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MoneyHubLinkPage',
    setup(__props) {
        useAuth();
        const state = useAppState();
        const { getCustomer: fetchCustomer } = useCustomer();
        const linkUrl = ref(null);
        function linkAccount() {
            if (linkUrl.value) {
                window.location.href = linkUrl.value;
            }
        }
        function loadCustomer() {
            fetchCustomer(() => {
                getHttpInstance().get(state.api + "/Customers/00000000-0000-0000-0000-000000000000/OpenFinance/LinkUrl")
                    .then((result) => {
                    linkUrl.value = result.data;
                });
            });
        }
        onMounted(() => {
            loadCustomer();
        });
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "centered" }, [
                    _createElementVNode("img", {
                        class: "pageHeaderIconBigger",
                        src: _imports_0
                    })
                ], -1)),
                (!_unref(state).customer)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_1, "Authenticating . . ."))
                    : _createCommentVNode("", true),
                (_unref(state).customer)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Why Link Your Investment Accounts?", -1)),
                        _cache[2] || (_cache[2] = _createElementVNode("p", null, "It's safe and secure. Money Guided has the same security standards as banks.", -1)),
                        _cache[3] || (_cache[3] = _createElementVNode("p", null, "See all your balances in one place.", -1)),
                        _cache[4] || (_cache[4] = _createElementVNode("p", null, "Receive money-saving guidance based on your financial situation.", -1)),
                        _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "mt-4" }, "Money Guided:", -1)),
                        _cache[6] || (_cache[6] = _createElementVNode("p", null, "Never see or store your login details.", -1)),
                        _cache[7] || (_cache[7] = _createElementVNode("p", null, "Uses 256-bit encryption to connect to your financial institution.", -1)),
                        _cache[8] || (_cache[8] = _createElementVNode("p", null, [
                            _createElementVNode("small", null, "Money Guided is registered with the Financial Conduct Authority under the Payment Services Regulations 2017 for the provision of payment services.")
                        ], -1)),
                        _createElementVNode("p", null, [
                            (linkUrl.value)
                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                    key: 0,
                                    onClick: linkAccount
                                }, {
                                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                                        _createTextVNode("Proceed")
                                    ])),
                                    _: 1
                                }))
                                : _createCommentVNode("", true)
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
